// extracted by mini-css-extract-plugin
module.exports = {"final-report-actionable-alterations":"FinalReportActionableAlterations_final-report-actionable-alterations__2bxMo"};